import { render } from "./PanelTipsterEvolucion.vue?vue&type=template&id=48a3b98c&scoped=true"
import script from "./PanelTipsterEvolucion.vue?vue&type=script&lang=js"
export * from "./PanelTipsterEvolucion.vue?vue&type=script&lang=js"

import "./PanelTipsterEvolucion.vue?vue&type=style&index=0&id=48a3b98c&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a3b98c"]])

export default __exports__